import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Header } from '@cheetahdigital/console-kit-cx';
import classNames from '../../../node_modules/classnames/index.js';
import styles from './index.module.scss.js';

var Headline = function (_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? "medium" : _b, _c = _a.weight, weight = _c === void 0 ? "regular" : _c, _d = _a.isUppercase, isUppercase = _d === void 0 ? false : _d, _e = _a.isGapless, isGapless = _e === void 0 ? true : _e, byline = _a.byline;
    return (jsx("div", __assign({ className: classNames(styles.header, isUppercase && styles.isUppercase, isGapless && styles.isGapless) }, { children: jsx(Header, { text: children, size: size, font: { weight: weight }, byline: byline }, void 0) }), void 0));
};

export { Headline as default };
